









import { mapCollectionToSelectOptions } from '@/helper/collection';
import { upperFirst } from 'lodash/string';
import Vue from 'vue';

export default Vue.extend({
  name: 'ApiSelect',
  props: {
    value: {
      required: true,
    },
    apiEndpoint: {
      required: true,
    },
    textField: {
      required: false,
      default: 'name',
    },
    valueField: {
      required: false,
      default: 'id',
    },
    all: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  async created(): Promise<void> {
    await this.fetchItems();
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data: () => ({
    items: [],
  }),
  computed: {
    selectItems(): { value: any; text: string }[] {
      return this.items.map((item) => ({
        value: item.value,
        text: item.lang ? upperFirst(this.$t(item.lang)) : item.text,
      }));
    },
  },
  methods: {
    async fetchItems(): Promise<void> {
      if (!this.apiEndpoint) {
        this.items = [];
        return;
      }
      const response = await this.$http.get(this.apiEndpoint);
      this.items = response.data.map(
        mapCollectionToSelectOptions(this.textField, this.valueField),
      );
      if (this.all) {
        this.items = [
          {
            lang: 'common.all',
            value: null,
          },
          ...this.items,
        ];
      }
    },
  },
  watch: {
    async apiEndpoint(): Promise<void> {
      await this.fetchItems();
    },
  },
});
